module.exports = __webpack_public_path__ + "img/about-patent9.bdcc2e1.png";